export const bailiffDialogUrlAudioSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogUrlAudio;
export const bailiffDialogSecondSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogSecond;
export const bailiffDialogPlaySelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogPlay;
export const bailiffDialogKickSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogKick;
export const bailiffDialogSlotSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogSlot;
//
export const bailiffDialogOptionSpeakerSelector = (state) =>
  state?.bailiffDialogReducer?.bailiffDialogOptionSpeaker;
